import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ViewjobEmployerDossierQueryVariables = Types.Exact<{
  input: Types.Scalars['ID']['input'];
}>;


export type ViewjobEmployerDossierQuery = { __typename?: 'Query', jobData: { __typename?: 'JobDataPayload', results: Array<{ __typename?: 'JobDataResult', job: { __typename?: 'Job', key: string, employer?: { __typename?: 'Employer', dossier?: { __typename?: 'EmployerDossier', brandColor?: string | null, images?: { __typename?: 'ImageBundle', squareLogoUrls?: { __typename?: 'SquareLogoUrlBundle', url256: string } | null } | null } | null } | null } }> } };

export type EmployerDossierFragment = { __typename?: 'Job', key: string, employer?: { __typename?: 'Employer', dossier?: { __typename?: 'EmployerDossier', brandColor?: string | null, images?: { __typename?: 'ImageBundle', squareLogoUrls?: { __typename?: 'SquareLogoUrlBundle', url256: string } | null } | null } | null } | null };

export const EmployerDossierFragmentDoc = gql`
    fragment EmployerDossier on Job {
  key
  employer {
    dossier {
      brandColor
      images {
        squareLogoUrls {
          url256
        }
      }
    }
  }
}
    `;
export const ViewjobEmployerDossierDocument = gql`
    query viewjobEmployerDossier($input: ID!) {
  jobData(jobKeys: [$input]) {
    results {
      job {
        ...EmployerDossier
      }
    }
  }
}
    ${EmployerDossierFragmentDoc}`;

/**
 * __useViewjobEmployerDossierQuery__
 *
 * To run a query within a React component, call `useViewjobEmployerDossierQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewjobEmployerDossierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewjobEmployerDossierQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useViewjobEmployerDossierQuery(baseOptions: Apollo.QueryHookOptions<ViewjobEmployerDossierQuery, ViewjobEmployerDossierQueryVariables> & ({ variables: ViewjobEmployerDossierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewjobEmployerDossierQuery, ViewjobEmployerDossierQueryVariables>(ViewjobEmployerDossierDocument, options);
      }
export function useViewjobEmployerDossierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewjobEmployerDossierQuery, ViewjobEmployerDossierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewjobEmployerDossierQuery, ViewjobEmployerDossierQueryVariables>(ViewjobEmployerDossierDocument, options);
        }
export function useViewjobEmployerDossierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewjobEmployerDossierQuery, ViewjobEmployerDossierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewjobEmployerDossierQuery, ViewjobEmployerDossierQueryVariables>(ViewjobEmployerDossierDocument, options);
        }
export type ViewjobEmployerDossierQueryHookResult = ReturnType<typeof useViewjobEmployerDossierQuery>;
export type ViewjobEmployerDossierLazyQueryHookResult = ReturnType<typeof useViewjobEmployerDossierLazyQuery>;
export type ViewjobEmployerDossierSuspenseQueryHookResult = ReturnType<typeof useViewjobEmployerDossierSuspenseQuery>;
export type ViewjobEmployerDossierQueryResult = Apollo.QueryResult<ViewjobEmployerDossierQuery, ViewjobEmployerDossierQueryVariables>;